import React, { Fragment, useCallback, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { EditSlots, EditOptions } from 'src/types/general';
import Form, { Props as FormProps } from '../Form/Form';

export interface Props extends FormProps {
	title?: string;
	options?: EditOptions;
	slots?: EditSlots;
}

export function EditPopup(props: Props) {
	const { title, options = {}, slots, onCancel } = props;
	const [extraData, setExtraData] = useState({});
	const [show, setShow] = useState(props.record !== null && props.record !== 'undefined');
	const [dirty, setDirty] = useState(false);
	const [helpers, setHelpers] = useState<any>();

	// trigger validation when extraData change
	useEffect(() => {
		if (helpers) {
			helpers.validateForm();
		}
	}, [helpers, extraData]);
	//

	const handleDirty = useCallback((flag) => {
		setDirty(flag);
	}, []);

	const handleClose = useCallback(
		(forceExit?) => {
			if (dirty && !forceExit) {
				if (window.confirm(`Continuando perderai tutte le tue modifiche. Vuoi continuare?`)) {
					setShow(false);
					setDirty(false);
					onCancel();
				}
			} else {
				setShow(false);
				onCancel();
			}
		},
		[dirty]
	);

	const onSetHelpers = useCallback(({ form }) => {
		setHelpers({
			...form,
		});
	}, []);

	const onAddExtraData = useCallback(
		(values) => {
			setExtraData({
				...extraData,
				...values,
			});
		},
		[extraData]
	);

	const handleClosed = () => {
		// onCancel();
	};

	const DefaultForm = useCallback((props) => {
		return (
			<Form
				{...props}
				onAddExtraData={onAddExtraData}
				onSetHelpers={onSetHelpers}
				onDirty={handleDirty}
				onCancel={handleClose}
			/>
		);
	}, []);

	const FormPopup = slots && slots.form ? slots.form : DefaultForm;

	if (slots && slots.edit) {
		const Edit = slots.edit;
		return (
			<Fragment>
				<Edit
					{...props}
					{...{
						dirty,
						show,
						handleClose,
						handleClosed,
						extraData,
					}}
					onAddExtraData={onAddExtraData}
				>
					<FormPopup {...props} extraData={extraData} />
				</Edit>
			</Fragment>
		);
	}
	return (
		<div>
			<Modal
				show={show}
				fullscreen={(options && options.fullScreen) as any}
				onHide={handleClose}
				onExited={handleClosed}
				size={(options || {}).modalSize || 'xl'}
			>
				<Modal.Header closeButton>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<FormPopup {...props} extraData={extraData} />
				</Modal.Body>

				{/*
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>Chiudi senza salvare</Button>
					<Button variant="primary" onClick={handleClose}>Salva</Button>
				</Modal.Footer>
				*/}
			</Modal>
		</div>
	);
}

export default EditPopup;
